import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isEqual } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CartItemsService {
  
  private approvalStageMessage = new BehaviorSubject<any>("mess");
  currentApprovalStageMessage = this.approvalStageMessage.asObservable();

  constructor() {}

  updateApprovalMessage(response: object) {
    if (!isEqual(this.approvalStageMessage.getValue(), response)) {
      this.approvalStageMessage.next(response);
    }
  }
}
